import { DISEASE } from 'utils/constants/disease';

export const TREATMENT_QUESTION_ID_BY_DISEASE = {
  [DISEASE.AML]: 'treatment_for_aml',
  [DISEASE.BLADDER]: 'treatment_for_bladder_cancer',
  [DISEASE.BLADDER_2]: 'treatment_for_bladder_cancer',
  [DISEASE.MELANOMA_2]: 'treatment_for_melanoma',
  [DISEASE.CRC]: 'treatment_for_crc_cancer',
  [DISEASE.CRC_2]: 'treatment_for_crc_cancer',
  [DISEASE.MDS]: 'treatment_for_mds',
  [DISEASE.MPN]: 'treatment_for_mpn',
  [DISEASE.UTERINE]: 'treatment_for_uterine_cancer',
  [DISEASE.BRAIN]: 'treatment_for_brain_cancer',
  [DISEASE.MM]: 'treatment_for_mm',
  [DISEASE.LUNG]: 'treatment_for_lung_cancer',
  [DISEASE.BREAST_2]: 'treatment_for_breast_cancer',
  [DISEASE.NHL]: 'treatment_for_lymphoma',
  [DISEASE.PROSTATE]: 'treatment_for_prostate_cancer',
  [DISEASE.HNSCC]: 'treatment_for_hnscc',
  [DISEASE.CLL]: 'treatment_for_cll',
  [DISEASE.GI_TRACT]: 'treatment_for_gi_tract',
  [DISEASE.OVARIAN]: 'treatment_for_ovarian_cancer',
  [DISEASE.HCC]: 'treatment_for_liver',
  [DISEASE.RCC]: 'treatment_for_kidney_cancer',
  [DISEASE.MESO]: 'treatment_for_mesothelioma_cancer',
  [DISEASE.GENERAL]: 'treatment_for_cancer',
  [DISEASE.CML]: 'treatment_for_cml',
  [DISEASE.SARCOMA]: 'treatment_for_sarcoma',
  [DISEASE.CERVICAL]: 'treatment_for_cervical_cancer',
};

export const PROCEDURE_QUESTION_ID_BY_DISEASE = {
  [DISEASE.BLADDER_2]: 'had_surgery_for_bladder_cancer',
  [DISEASE.BREAST_2]: 'had_procedure_for_breast_cancer',
  [DISEASE.CRC_2]: 'had_procedure_for_crc_cancer',
  [DISEASE.GI_TRACT]: 'had_procedure_for_gi_cancer',
  [DISEASE.HCC]: 'had_procedure',
  [DISEASE.HNSCC]: 'had_procedure',
  [DISEASE.LUNG]: 'had_procedure_for_lung_cancer',
  [DISEASE.NHL]: 'had_procedure_for_lymphoma',
  [DISEASE.OVARIAN]: 'had_procedure_for_ovarian_cancer',
  [DISEASE.PROSTATE]: 'had_procedure_for_prostate_cancer',
  [DISEASE.UTERINE]: 'had_procedure_for_uterine_cancer',
  [DISEASE.RCC]: 'had_procedure_for_kidney_cancer',
  [DISEASE.MESO]: 'had_procedure_for_mesothelioma_cancer',
  [DISEASE.GENERAL]: 'had_procedure_for_gi_cancer',
  [DISEASE.SARCOMA]: 'had_procedure_for_sarcoma',
  [DISEASE.CERVICAL]: 'had_procedure_for_cervical_cancer',
};

export const QUESTION_IDS_BY_DISEASE = {
  [DISEASE.MELANOMA_2]: {
    diseaseType: 'melanoma_subtype',
    patientStage: 'current_stage',
  },
  [DISEASE.MDS]: {
    diseaseType: 'type_of_mds',
    riskGroup: 'risk_group',
  },
  [DISEASE.MPN]: {
    diseaseType: 'type_of_mpn',
    riskGroup: 'risk_group',
  },
  [DISEASE.UTERINE]: {
    diseaseType: 'type_of_uterine_cancer',
    patientStage: 'current_stage',
    type_of_carcinoma: 'type_of_carcinoma',
    type_of_sarcoma: 'type_of_sarcoma',
  },
  [DISEASE.BRAIN]: {
    diseaseType: 'brain_cancer_type',
  },
  [DISEASE.MM]: {
    diseaseType: 'type_of_mm',
  },
  [DISEASE.LUNG]: {
    diseaseType: 'type_of_lung_cancer',
    patientStage: 'current_stage',
  },
  [DISEASE.BREAST_2]: {
    diseaseType: 'type_of_bc',
    patientStage: 'patient_stage',
    molecular_subtype: 'molecular_subtype',
  },
  [DISEASE.NHL]: {
    diseaseType: 'type_of_lymphoma',
    patientStage: 'current_stage',
    type_of_tcell_lymphoma: 'type_of_tcell_lymphoma',
    type_of_bcell_lymphoma: 'type_of_bcell_lymphoma',
    type_of_aids_related_lymphoma: 'type_of_aids_related_lymphoma',
  },
  [DISEASE.CRC_2]: {
    diseaseType: 'type_of_crc',
    patientStage: 'current_stage',
    type_of_familial_cancer: 'type_of_familial_cancer',
  },
  [DISEASE.PROSTATE]: {
    diseaseType: 'type_of_pc',
    patientStage: 'current_stage',
    patientSubStage: 'sub_stage',
  },
  [DISEASE.AML]: {
    diseaseType: 'type_of_aml',
    riskGroup: 'risk_group',
    riskGroupApl: 'risk_group_apl',
  },
  [DISEASE.HNSCC]: {
    diseaseType: 'type_of_hnscc',
    patientStage: 'current_stage',
  },
  [DISEASE.BLADDER_2]: {
    diseaseType: 'type_of_bladder_cancer',
    patientStageNmibc: 'patient_stage_nmibc',
    patientStageMibc: 'patient_stage_mibc',
    patientStageMet: 'patient_stage_met',
  },
  [DISEASE.CLL]: {
    diseaseType: 'type_of_disease',
    patientStage: 'disease_stage',
    riskGroupIpi: 'risk_group_ipi',
  },
  [DISEASE.GI_TRACT]: {
    diseaseType: 'type_of_gi',
    patientStage: 'current_stage',
  },
  [DISEASE.OVARIAN]: {
    diseaseType: 'type_of_ovarian_cancer',
    patientStage: 'current_stage',
    type_of_ovarian_cancer: 'type_of_ovarian_cancer',
  },
  [DISEASE.HCC]: {
    diseaseType: 'type_of_liver',
    patientStage: 'current_stage',
  },
  [DISEASE.MESO]: {
    patientStage: 'patient_stage',
  },
  [DISEASE.RCC]: {
    patientStage: 'patient_stage',
  },
  [DISEASE.GENERAL]: {
    patientStage: 'patient_stage',
  },
  [DISEASE.SARCOMA]: {
    diseaseType: 'sarcoma_type',
    patientStage: 'patient_stage',
  },
  [DISEASE.CERVICAL]: {
    diseaseType: 'type_of_cervical_cancer',
    patientStage: 'patient_stage',
  },
};

export const DISEASE_SUB_TYPE_QUESTION_ID_BY_DISEASE = {
  [DISEASE.MELANOMA_2]: 'melanoma_subtype',
  [DISEASE.MM]: 'type_of_mm',
  [DISEASE.MPN]: 'type_of_mpn',
  [DISEASE.AML]: 'type_of_aml',
  [DISEASE.CLL]: 'type_of_disease',
  [DISEASE.CRC]: 'type_of_crc',
  [DISEASE.CRC_2]: 'type_of_crc',
  [DISEASE.GI_TRACT]: 'type_of_gi',
  [DISEASE.HCC]: 'type_of_liver',
  [DISEASE.HNSCC]: 'type_of_hnscc',
  [DISEASE.LUNG]: 'type_of_lung_cancer',
  [DISEASE.MDS]: 'type_of_mds',
  [DISEASE.MELANOMA]: 'melanoma_subtype',
  [DISEASE.NHL]: 'type_of_lymphoma',
  [DISEASE.OVARIAN]: 'type_of_ovarian_cancer',
  [DISEASE.PROSTATE]: 'type_of_pc',
  [DISEASE.UTERINE]: 'type_of_uterine_cancer',
  [DISEASE.BLADDER]: 'type_of_bladder_cancer',
  [DISEASE.BLADDER_2]: 'type_of_bladder_cancer',
  [DISEASE.BRAIN]: 'brain_cancer_type',
  [DISEASE.BREAST_2]: 'molecular_subtype',
  [DISEASE.RCC]: 'type_of_cc',
  [DISEASE.MESO]: 'type_of_mesothelioma_cancer',
  [DISEASE.GENERAL]: 'type_of_ca',
  [DISEASE.CML]: 'cml_phase',
  [DISEASE.SARCOMA]: 'sarcoma_type',
  [DISEASE.CERVICAL]: 'type_of_cervical_cancer',
};

// group of question ids referred in the code by subtype alias
export const SUBTYPE_ALIAS_QUESTION_IDS_BY_DISEASE = {
  [DISEASE.BREAST_2]: ['molecular_subtype', 'other_type_bc'],
  [DISEASE.UTERINE]: ['type_of_carcinoma', 'type_of_sarcoma'],
  [DISEASE.CRC_2]: ['type_of_familial_cancer'],
  [DISEASE.GI_TRACT]: ['type_of_esophageal_gej'],
  [DISEASE.LUNG]: ['type_of_nsclc'],
  [DISEASE.MELANOMA_2]: ['melanoma_subtype', 'melanoma_subtype_mucosal'],
  [DISEASE.MPN]: ['type_of_mf', 'type_of_cmml'],
  [DISEASE.NHL]: [
    'type_of_marginal_cell_lymphoma',
    'type_of_dlbcl',
    'type_of_tcell_lymphoma',
    'type_of_bcell_lymphoma',
    'type_of_aids_related_lymphoma',
  ],
  [DISEASE.OVARIAN]: ['type_of_non_epithelial_disease'],
  [DISEASE.MESO]: ['histological_type_of_mesothelioma'],
  [DISEASE.GENERAL]: ['type_of_pancreatic'],
  [DISEASE.SARCOMA]: [
    'type_of_liposarcoma',
    'type_of_kaposi_sarcoma',
    'type_of_rhabdomyosarcoma',
    'type_of_leiomyosarcoma',
    'type_of_chondrosarcoma',
  ],
  [DISEASE.CERVICAL]: [
    'neuroendocrine_type',
    'hpv_independent_adenocarcinoma',
  ],
};
